module.exports = __webpack_public_path__ + "img/4.466e019c.png";